var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowsE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 7,
    viewBox: "0 0 95 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3559 2.87929C34.7441 5.08618 34.3428 6.37736 32.3559 6.13929C17.9516 4.41343 5.5339 6.52282 4.04379 6.52282C2.55368 6.52282 -3.64667 8.61738 3.05037 4.02988C10.5806 -1.12839 28.0086 -1.13791 32.3559 2.87929Z",
    className: "Brows"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4927 2.93267C60.1943 5.20661 60.5036 6.38387 62.4927 6.14899C76.9129 4.44626 89.3443 6.52738 90.8361 6.52738C92.3279 6.52738 98.5316 8.599 91.8306 4.06784C83.8845 -1.30532 66.4769 -1.00915 62.4927 2.93267Z",
    className: "Brows"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsE);
export default __webpack_public_path__ + "static/media/Brows E.f478ca83c20b24813bd4d615116ecc03.svg";
export { ForwardRef as ReactComponent };